import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://405c521451d3e0ad291d624795a41ebd@o4508062761353216.ingest.us.sentry.io/4508062764761088",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});